
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'HeaderSearch',
  data() {
    return {
      inputText: '',
      currentFocus: -1,
      toggle: false,
    }
  },
  computed: {
    ...mapState('initial', ['initial']),
    CorpList() {
      const CorpList = this.initList()
      const parsedobj = CorpList && JSON.parse(JSON.stringify(CorpList))
      if (this.inputText.length > 1) {
        const q = this.inputText.toLowerCase().trim()
        const result =
          parsedobj &&
          parsedobj.filter(
            (item) =>
              item.code.toLowerCase().includes(q) ||
              item.name.toLowerCase().includes(q)
          )
        if (!result || result.length === 0) {
          return [{ name: '해당되는 종목이 없습니다.' }]
        } else {
          result.sort((a, b) => {
            if (a.name.length > b.name.length) return 1
            if (a.name.length < b.name.length) return -1

            if (a.name > b.name) return -1
            if (a.name < b.name) return 1

            if (a.name.localeCompare(b.name) > b.name.localeCompare(a.name)) return -1
            if (a.name.localeCompare(b.name) < b.name.localeCompare(a.name)) return 1
          })

          return result
        }
      }

      return ''
    },
  },
  watch: {
    inputText() {
      if (this.inputText.length > 1) {
        this.toggle = true
      } else {
        this.toggle = false
      }

      this.currentFocus = -1

      if (this.$refs.li_refs !== undefined) {
        this.removeActive()
      }
    },
  },

  beforeMount() {
    window.addEventListener('click', this.closeAllLists)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.closeAllLists)
  },

  created() {
    this.requestInit()
  },

  methods: {
    ...mapActions('initial', ['GET_INIT_DATA']),
    ...mapGetters('initial', ['initList']),

    hitEnter(event) {
      const text = (this.inputText || '').trim()

      // 입력값 체크
      if (text === '') {
        alert('코드나 종목명을 입력해주세요.')
        return
      }

      const list = Array.isArray(this.CorpList) ? this.CorpList : []

      // 자동완성 결과가 "없습니다"인 경우
      if (list[0] && list[0].code === undefined) {
        alert('상장폐지되었거나 존재하지 않는 종목입니다.')
        this.clearInput()
        return
      }

      if (this.toggle && this.currentFocus > -1 && list[this.currentFocus]) {
        const picked = list[this.currentFocus]
        if (picked && picked.code) {
          this.onBoxClick(picked) // 여기서 라우팅/조회까지 처리됨
          return
        }
      }
      if (this.toggle && list[0] && list[0].code) {
        this.onBoxClick(list[0])
        return
      }
      this.linkPage()
      this.clearInput()
    },

    clearInput() {
      this.inputText = ''
      if (this.$refs.headersearch) this.$refs.headersearch.value = ''
      this.toggle = false
      this.currentFocus = -1
    },

    requestInit() {
      const params = { body: '' }
      this.GET_INIT_DATA(params)
    },

    linkPage() {
      const targetCode = String(this.inputText || '').trim()
      if (!targetCode) {
        return
      }
      this.goAnalysisPage(targetCode)
    },

    onBoxClick(item) {
      if (!item || !item.code) {
        return
      }
      this.goAnalysisPage(item.code)
    },
    goAnalysisPage(code) {
      const targetCode = String(code || '').trim()
      if (!targetCode) {
        return
      }
      this.clearInput()
      const result = this.$router.push({
        path: '/Company/Analysis/StockInfo',
        query: {
          code: targetCode,
        },
      })
      if (result && result.catch) {
        result.catch(() => {})
      }
      this.$emit('close')
    },

    outboundScrolling() {
      const ref = this.$refs.li_refs
      if (!ref || !ref[this.currentFocus]) return

      if (ref[this.currentFocus].offsetTop < ref[this.currentFocus].parentNode.scrollTop) {
        ref[this.currentFocus].parentNode.scrollTop = ref[this.currentFocus].offsetTop
      } else if (
        ref[this.currentFocus].offsetTop >
        ref[this.currentFocus].parentNode.scrollTop +
          ref[this.currentFocus].parentNode.clientHeight -
          ref[this.currentFocus].clientHeight
      ) {
        ref[this.currentFocus].parentNode.scrollTop =
          ref[this.currentFocus].offsetTop -
          (ref[this.currentFocus].parentNode.clientHeight - ref[this.currentFocus].clientHeight)
      }
    },

    keyEscape() {
      this.toggle = false
      this.currentFocus = -1
    },

    keyDown(e) {
      e.preventDefault()
      const ref = this.$refs.li_refs
      if (!ref || !ref.length) return

      if (ref.length - 1 > this.currentFocus) {
        this.removeActive()
        this.currentFocus++
        ref[this.currentFocus].classList.add('autocomplete-active')
        this.outboundScrolling()
      }
    },

    keyUp(e) {
      e.preventDefault()
      const ref = this.$refs.li_refs
      if (!ref || !ref.length) return

      if (this.currentFocus > 0) {
        this.removeActive()
        this.currentFocus--
        ref[this.currentFocus].classList.add('autocomplete-active')
        this.outboundScrolling()
      }
    },

    removeActive() {
      if (!this.$refs.li_refs) return
      for (let i = 0; i < this.$refs.li_refs.length; i++) {
        this.$refs.li_refs[i].classList.remove('autocomplete-active')
      }
    },
    closeAllLists(e) {
      if (this.$el && !this.$el.contains(e.target)) {
        this.toggle = false
        this.currentFocus = -1
      }
    },
  },
}
